export default __webpack_public_path__ + "static/media/stop.f028bd87.svg";